module.exports = __webpack_public_path__ + "static/media/buengift-tuto.2884bad3.mp4";